import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
export function TemplatesIcon(props) {
    const themeContext = useContext(ThemeContext);
    const { color = 'TextSubtleGrey', ...rest } = props;
    const primaryFillColor = themeContext.colors[color];
    return (_jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...rest, children: _jsx("path", { d: "M7.3 4H4v16.5h3.3V4zM20.5 10.6h-3.3v9.9h3.3v-9.9zM20.502 4h-9.9v3.3h9.9V4zM13.902 17.2h-3.3v3.3h3.3v-3.3zM13.902 10.6h-3.3v3.3h3.3v-3.3z", stroke: primaryFillColor, strokeWidth: 1.5, strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }) }));
}
//# sourceMappingURL=Templates.js.map